/**
 * recipeCards — split from `data.ts`'s legacy `PACKS` array into its own
 * module (narcis file-split shape), plan `thinking/plans/2026_08_31_toile_pack_wiring.md` Track A,
 * script `generation/scripts/packs/toile_split_data.py`.
 */
import {A4, tagline, chips, type ToilePack} from './data'

export const recipeCardsPack: ToilePack = {
    slug: 'recipe-cards',
    category: 'recipe',
    name: 'Recipe cards',
    tagline: tagline('cards', 'kinds', 'styles'),
    chips: chips('kinds', 'styles'),
    ratio: A4,
    readings: [
        {key: 'baking', label: 'Baking', subject: 'a whisk, rolling pin, mixing bowl and a rack of buns'},
        {key: 'family', label: 'Family recipe', subject: 'a wooden spoon, a checked cloth and worn cards'},
        {key: 'cocktail', label: 'Cocktail', subject: 'a coupe glass, a shaker, a citrus wheel and mint'},
    ],
    styles: [
        {key: 'farmhouse', label: 'Farmhouse', style: 'a gingham header band, a weathered printed look', palette: 'muted red and sage on cream stock', framing: 'header band, ingredients column, method area'},
        {key: 'botanical', label: 'Botanical line', style: 'fine single-weight ink drawings, hairline rules', palette: 'one accent color on bright white', framing: 'header band, ingredients column, method area'},
        {key: 'diner', label: 'Retro diner', style: 'bold 1950s shapes, chunky borders, halftone dots', palette: 'cherry red and turquoise on cream', framing: 'header band, ingredients column, method area'},
    ],
    directions: ['for barbecue instead', 'in black and cream', 'with a prep-time line'],
}
